import HeaderSearch from '../components/HeaderSearch.svelte';
import HeaderSearchPanel from '../components/HeaderSearchPanel.svelte';

let targets = document.querySelectorAll('.header-search')
let apps:any = [];

targets.forEach(target => {
    const classList = target.querySelector('input[type="search"]')?.className;

    apps.push(new HeaderSearch({
        hydrate: true,
        props: {
            classList,
            ...target.dataset
        },
        target
    }))
});

if (document.querySelector('#header-search-panel')) {
    apps.push(new HeaderSearchPanel({
        hydrate: true,
        target: document.querySelector('#header-search-panel')
    }));
}

document.querySelectorAll('.toggle-search').forEach(toggle => toggle.addEventListener('click', () => {
        //dispatchEvent "toggle-search"
        document.dispatchEvent(new CustomEvent('toggle-search'));
    }));

export default apps;
